import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    currentUserId: (state) => state.currentUser.id,
    tryingToLogin: (state) => state.tryingToLogin,
    tryingToSignUp: (state) => state.tryingToSignUp,
    tryingToVerifyPhone: (state) => state.tryingToVerifyPhone,
    successSignup: (state) => state.successSignup,
    successForgotPassword: (state) => state.successForgotPassword,
    successCreatePassword: (state) => state.successCreatePassword,
    currentNotifications: (state) => state.currentNotifications,
    notificationSettings: (state) => state.notificationSettings,
    companiesForLogin: (state) => state.companiesForLogin,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'isTryingToLogin',
    'isTryingToSignup',
    'isTryingToVerifyPhone',
    'canManageCompanies',
    'canEditCompany',
    'canEditGroup',
    'canViewCompany',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logInWithProvider',
  'signUp',
  'logOut',
  'forgotPassword',
  'createPassword',
  'tryingToLoginError',
  'verifyPhone',
  'verifyCode',
  'resendCode',
  'toggleFollowTag',
  'loginByCode',
  'acceptedHubInvite',
  'rejectedHubInvite',
  'getAllCompanies',
])
